import { render, staticRenderFns } from "./save-btn-container.vue?vue&type=template&id=34c8c71d&scoped=true&"
import script from "./save-btn-container.vue?vue&type=script&lang=js&"
export * from "./save-btn-container.vue?vue&type=script&lang=js&"
import style0 from "./save-btn-container.vue?vue&type=style&index=0&id=34c8c71d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c8c71d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c8c71d')) {
      api.createRecord('34c8c71d', component.options)
    } else {
      api.reload('34c8c71d', component.options)
    }
    module.hot.accept("./save-btn-container.vue?vue&type=template&id=34c8c71d&scoped=true&", function () {
      api.rerender('34c8c71d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/popups/save-btn-container.vue"
export default component.exports